export default {
  id: 'expense-review',
  title: 'Expense Review',
  category: 'Admin',
  summary: 'Approve, reject, or mark processed expense reports — and import historical reports on behalf of employees.',
  overview: 'Expense Review is the administrative queue for travel, general business, and other direct cost reports. Reviewers validate estimates, purchase requests, and actuals. Administrators can also proxy-import historical reports without involving the employee in the normal submit flow.',
  howItWorks: [
    'Submitted employee reports appear in the review queue by type and status.',
    'Opening a report shows line items, attachments, and workflow context.',
    'Approving advances the report (for example, authorizing purchase or accepting actuals).',
    'Rejecting returns it to the employee with a reason.',
    'Marking processed records that reimbursement or back-office handling is complete.',
    'Import expense report creates a proxy report for an employee; those appear with a Proxy badge and under In Progress Imports until finalized.'
  ],
  actions: [
    {
      name: 'Open a report',
      description: 'Loads the type-specific review detail page (travel, general business, or ODC).'
    },
    {
      name: 'Approve',
      description: 'Accepts the current submission stage and moves the report forward in its workflow.'
    },
    {
      name: 'Reject',
      description: 'Returns the report to the employee with a rejection reason for correction.'
    },
    {
      name: 'Mark processed',
      description: 'Indicates administrative processing (such as reimbursement) is finished.'
    },
    {
      name: 'Import expense report',
      description: 'Starts a proxy import for historical Travel, General Business, or ODC data. See Import Expense Report help for the full workflow.'
    },
    {
      name: 'Finalize / resume proxy import',
      description: 'From In Progress Imports, finalize closes the proxy report; resume reopens a finalized import for more edits.'
    }
  ],
  tips: [
    'Check receipts and project associations carefully on actuals before approving reimbursement.',
    'Clear rejection reasons reduce back-and-forth with employees.',
    'Proxy imports do not send status emails — notify the employee separately if needed.'
  ],
  related: ['expense-import', 'expenses', 'travel-expense', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/expense-review.js